import React, { useState } from "react";
import { downloadPdf } from "../utils/functions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
  Button,
} from "@material-ui/core";
import { stateToFile } from "../utils/functions";

export default ({ close, isDownloadPdfOpen }) => {
  const [fileName, setFileName] = useState("features");

  const downloadPdfHandler = () =>{
    try {
      downloadPdf(fileName, stateToFile({description:false}));
      close();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Dialog open={isDownloadPdfOpen} onClose={close}>
      <DialogTitle id="form-dialog-title">Download PDF</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="File Name"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">.pdf</InputAdornment>
            ),
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Cancel
        </Button>
        <Button
          onClick={downloadPdfHandler}
          color="primary"
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};
